import React from "react";
import { EditOutlined } from "@mui/icons-material";
import { Button, Divider } from "@mui/material";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import EnableDisableButton from "components/Shared/EnableDisableButton";
import CodTransferBasicDetail from "../CodTransfer/codTransferComponents/CodTransferBasicDetail";
import { useAppMeta, useAuth } from "hooks";
import {
  CodTransferDetailContext,
  useCodTransferDetailContext,
} from "contexts/PaymentContexts/CodTransferContext";
import {
  useGetCodTransferDetailQuery,
  useUpdateCodTransferMutation,
} from "store/services/PaymentsApi/codTransferApi";
import CodTransferDetailTab from "./codTransferComponents/CodTransferDetailTab";

const CodTransferDetailScreen = () => {
  const { id } = useParams();
  const { isVendor } = useAuth();

  const breadcrumbs = [
    {
      title: "COD Transfer",
      path: isVendor
        ? "/app/vendor/cod-transfer/list"
        : "/app/crm/cod-transfer/list",
    },
    { title: "COD Transfer Detail" },
  ];

  const {
    data: CodTransferDetail,
    isLoading: loadingCodTransferDetail,
    error,
  } = useGetCodTransferDetailQuery(id);

  useAppMeta("COD Transfer Detail");

  return (
    <CodTransferDetailContext.Provider
      value={{ CodTransferDetail, loadingCodTransferDetail }}
    >
      <BreadcrumbLayout
        breadcrumbs={breadcrumbs}
        isBusy={loadingCodTransferDetail}
        headerActions={<PageActions />}
      >
        <BreadcrumbLayout.Error error={error} />
        <BreadcrumbLayout.Paper>
          <CodTransferBasicDetail />
          <Divider />
          <CodTransferDetailTab />
        </BreadcrumbLayout.Paper>
      </BreadcrumbLayout>
    </CodTransferDetailContext.Provider>
  );
};

export default CodTransferDetailScreen;

const PageActions = () => {
  const { isVendor, isAccountAdmin } = useAuth();
  const { CodTransferDetail, loadingCodTransferDetail } =
    useCodTransferDetailContext();

  const [updateCodTransfer, { isLoading: updatingCodTransfer }] =
    useUpdateCodTransferMutation();

  const handleToggleStatus = async () => {
    try {
      await updateCodTransfer({
        _id: CodTransferDetail._id,
        isActive: !CodTransferDetail.isActive,
      }).unwrap();
      toast.info(
        `COD Transfer ${CodTransferDetail.isActive ? "Disabled" : "Enabled"}!`
      );
    } catch (error) {
      toast.error(error?.data?.message ?? "Could Not Update Status");
    }
  };

  return (
    <>
      {!isVendor && (
        <div className="flex space-x-4">
          {isAccountAdmin && (
            <EnableDisableButton
              isActive={CodTransferDetail?.isActive}
              loading={loadingCodTransferDetail || updatingCodTransfer}
              onClick={handleToggleStatus}
            />
          )}
          <Link to={`/app/crm/cod-transfer/${CodTransferDetail?._id}/edit`}>
            <Button startIcon={<EditOutlined />} variant="contained">
              Edit
            </Button>
          </Link>
        </div>
      )}
    </>
  );
};
